export default "__VITE_ASSET__DZxyW6pn__"